import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Document } from '../../../jurisdiction/jurisdiction.domain';
import { ErrorService } from '../../../services/error/error.service';
import { FileService } from '../../../services/file.service';
import { NetzTranslateService } from '../../../services/netz-translate.service';
import { NgForm, ControlContainer } from '@angular/forms';
import { FileEvent } from 'src/app/+shared/models/fileEvent';
import { DocumentAndInputName } from 'src/app/+shared/models/documentAndInputName';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FileUploadComponent implements OnInit {
  @Input() fileData: Document;
  @Input() inputName: any;
  @Input() type: string;
  @Input() label: string;
  @Input() isDetailsView: boolean;
  @Input() isClearButtonDisabled: boolean;
  @Input() isRequired: boolean = true;
  @Input() isUploadDisabled: boolean;

  @Output() clearFileEvent = new EventEmitter<FileEvent>();
  @Output() fileDataChangeEvent = new EventEmitter<DocumentAndInputName>();

  private applicationId: number;
  private allowedFileTypes: string[] = ['application/pdf', 'text/plain', 'image/jpg', 'image/jpeg', 'image/png', 'image/gif'];

  constructor(
    private fileService: FileService,
    private errorService: ErrorService,
    private translate: NetzTranslateService,
    private control: NgForm
  ) {}

  ngOnInit(): void {
    this.applicationId = Number(JSON.parse(localStorage.getItem('application_id')));
  }

  public clearInput(): void {
    if (this.fileData.document_id) {
      this.clearFileEvent.emit(new FileEvent(+this.fileData.document_id, `${this.inputName}Title`));
    }
    this.removePropsAfterDeleteFile(this.fileData);
    this.fileDataChangeEvent.emit(new DocumentAndInputName(this.fileData, this.inputName));
  }

  public onSelectFile(event: any, uploader: any): void {
    const file = event.currentFiles[0];
    if (this.fileService.isFileTypeAndSizeAllowed(file)) {
      this.fileData.file = file;
      this.fileData.filename = file.name;
      this.fileData.sk_document_type = this.type;
      this.fileData.name = this.type;
      this.fileData.application_id = this.applicationId.toString();
      this.control.form.controls[`${this.inputName}Title`]?.markAsDirty();
      this.fileDataChangeEvent.emit(new DocumentAndInputName(this.fileData, this.inputName));
    }

    uploader.clear();
  }

  public previewDocument(): void {
    if (!this.fileData.document_id || this.fileData.document_id === '0') {
      this.fileService.previewDocument(this.fileData.file, this.fileData.content_type, true);
    } else {
      this.fileService.readWorkflowDocument(this.fileData.document_id).subscribe(
        (response: Blob) => {
          this.errorService.throwErrorIfFailure(response, true);
          this.fileService.previewDocument(response, this.fileData.content_type);
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    }
  }

  public downloadDocument(): void {
    if (!this.fileData.document_id || this.fileData.document_id === '0') {
      this.fileService.downloadDocument(this.fileData.file, this.fileData.filename, true);
    } else {
      this.fileService.readWorkflowDocument(this.fileData.document_id).subscribe(
        (response: Blob) => {
          this.errorService.throwErrorIfFailure(response, true);
          this.fileService.downloadDocument(response, this.fileData.filename);
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    }
  }

  private removePropsAfterDeleteFile(document: Document) {
    for (const prop in document) {
      if (prop !== 'sk_document_type') {
        delete document[prop];
      }
    }
  }
}
